import React from 'react'
import {Table, ButtonGroup, Alert} from 'react-bootstrap'
import Icon from 'react-fa'
import {t} from '../../helpers/translate.js'
import {checkOrg,isMshAdmin} from '../../helpers/access'
let config = require('config');

class StripeComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentResponse: null,
      processingPayment: false,
      useStoredPaymentMethod: false
    }
  }

  componentDidMount() {
    this.stripe = Stripe(config.default.stripe_key);
    const elements = this.stripe.elements();
    this.card = elements.create('card');
    this.card.mount('#card-element');
  }

  handleSubmit(action) {
    this.setState({processingPayment: true});

    if(this.state.useStoredPaymentMethod){
      this.setState({processingPayment: false});
      action(this.props.applicationData.stored_payment_method);
    } else {
      return new Promise(async (resolve, reject) => {
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.card,
          billing_details: {
            name: document.getElementById('creditCardHolderName').value,
          },
        });
        this.setState({processingPayment: false});
        if (error !== undefined) return
        action(paymentMethod);
      });
    }
  }

  toggleUseStoredPaymentMethod(value) {
    this.setState({useStoredPaymentMethod: value}, function(){
      if (!this.state.useStoredPaymentMethod) {
        this.card.mount('#card-element');
      }
    });
  }

  render() {
    const storedCardDetails = this.props.applicationData.stored_payment_method
    const isRimiOr2Visit = checkOrg('rimi') || checkOrg('visitcanada')
    const isCanuckVoyageNonMedical = this.props.source === "rimicanuckvoyagenonmed"
    return <div>
      {
        !this.props.updatingCard && storedCardDetails && !(checkOrg('ingle') || checkOrg('msg')) &&
        <label className='form-control-static'><input type="checkbox"
          value="true"
          ref="checkbox"
          name="chargeCcOnFile"
          onChange={(event) => {this.toggleUseStoredPaymentMethod(event.target.checked)}}
        />Charge Credit Card on file</label>
      }
      {
        !this.state.useStoredPaymentMethod ?
        <div className="row">
          <div className="col-md-8">
            <div>
              <form ref="creditCardForm">
                {
                <div className='form-row'>
                  <input id='creditCardHolderName' name='cardholder-name' placeholder={t('Cardholder Name')} required />
                  <label htmlFor='card-element' />
                  <div id='card-element' />
                  <div id='card-errors' role='alert' />
                </div>
                }
              </form>
            </div>
          </div>
        </div>
        :
        <div>
          <Table hover>
            <tr><td>Cardholder Name</td><td>{storedCardDetails.billing_details.name}</td></tr>
            <tr><td>Card Type</td><td>{storedCardDetails.card.brand}</td></tr>
            <tr><td>Card Number</td><td>**** **** **** {storedCardDetails.card.last4}</td></tr>
            <tr><td>Expiry Date</td><td>{storedCardDetails.card.exp_month}/{storedCardDetails.card.exp_year}</td></tr>
          </Table>
        </div>
      }
      {
        (() => {
          if (this.state.paymentResponse && this.state.paymentResponse.error) {
            return <Alert bsStyle="danger">
              {this.state.paymentResponse.error.message}
            </Alert>
          }
        })()
      }
      {
        this.props.updatingCard &&
        <ButtonGroup>
          <button className="btn button-primary"
            onClick={this.props.toggleUpdatingCard}>
            {t('Cancel Update')}
          </button>
          <button className="btn button-secondary"
            onClick={this.handleSubmit.bind(this, this.props.updateCreditCard)}
            disabled={this.state.processingPayment}>
            {this.state.processingPayment && <Icon spin name="spinner"/>}
            {' '}
            {t('Update Card')}
          </button>
        </ButtonGroup>
      }
      {
        this.props.processingFailedPayments &&
        <ButtonGroup>
          <button className="btn button-primary"
            onClick={this.props.toggleProcessingFailedPayments}>
            {t('Cancel')}
          </button>
          <button className="btn button-primary"
            onClick={this.handleSubmit.bind(this, this.props.processFailedPayments)}
            disabled={this.state.processingPayment}>
            {this.state.processingPayment ? <Icon spin name="spinner"/> : null}
            {' '}
            {t('Process Payment')}
          </button>
        </ButtonGroup>
      }
      {
        this.props.quoteResponseData && this.props.quoteResponseData.premium_difference > 0 &&
        <div className="btn-group pull-left">
          <button className="btn button-primary"
              onClick={this.handleSubmit.bind(this, this.props.submitPremiumCharge)}
              disabled={this.state.processingPayment || !this.props.quoteResponseData}
              bsStyle={'primary'}>
            {(this.state.processingPayment || !this.props.quoteResponseData) ? <Icon spin name="spinner"/> : null}
            {t('Process Payment')}
          </button>

          {isRimiOr2Visit && isMshAdmin() && !isCanuckVoyageNonMedical && (
            <button className="btn button-secondary"
              style={{ marginLeft: '10px' }}
              onClick={this.props.saveChanges.bind(this, { pendPayment: true })}
              disabled={this.state.processingPayment || !this.props.quoteResponseData}
              bsStyle={'primary'}>
              {(this.state.processingPayment || !this.props.quoteResponseData) ? <Icon spin name="spinner" /> : null}
              {t('Pend Payment')}
            </button>
          )}
        </div>
      }
    </div>
  }
}

StripeComponent.displayName = 'StripeComponent';
export default StripeComponent;



// WEBPACK FOOTER //
// ./src/components/common/StripeComponent.js